exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shadow {\r\n    width: 100%;\r\n    z-index: 100;\r\n    display: block;\r\n    background: url(/assets/images/shadow.png) top repeat-x;\r\n    height: 6px;\r\n    position: absolute;\r\n    margin: 0;\r\n}   ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 738
// module chunks = 1